export default __webpack_public_path__ + "static/media/taiwan.733ab09f.svg";